import { AppLogo } from 'components/AppLogo/AppLogo'
import React, { useEffect, useState } from 'react'
import { StyledLoadingContainer, StyledChevronWrapper, StyledChevron, StyledTitleContainer } from './LoadingScreen.styled'



export const LoadingScreen: React.FC = () => {
  return (
    <React.Fragment>
      <StyledLoadingContainer>
        <StyledChevronWrapper>
          <StyledChevron
            viewBox="0 0 441 917" /* Adjusted to encompass both paths */
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M348.547 294.656L184.067 0.499989L0.750896 0.499981L256.961 458.716L0.750855 916.5L184.067 916.5L348.547 622.345L440.205 458.716L348.547 294.656Z"
              fill="#151515"
            />

          </StyledChevron>
          <StyledChevron
            viewBox="0 0 441 917"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M348.547 294.656L184.067 0.499989L0.750896 0.499981L256.961 458.716L0.750855 916.5L184.067 916.5L348.547 622.345L440.205 458.716L348.547 294.656Z"
              fill="#151515"
            />
          </StyledChevron>
          <StyledChevron
            viewBox="0 0 441 917"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M348.547 294.656L184.067 0.499989L0.750896 0.499981L256.961 458.716L0.750855 916.5L184.067 916.5L348.547 622.345L440.205 458.716L348.547 294.656Z"
              fill="#151515"
            />
          </StyledChevron>
        </StyledChevronWrapper>
        <StyledTitleContainer>
          <AppLogo />
        </StyledTitleContainer>
      </StyledLoadingContainer>
    </React.Fragment>
  )
}



